export const SCBICondition = {
    EXPOSED: 1,
    POSITIVE: 2
}